import { safeValue } from "../pages/repo/vehicles/findVehiclesHelpers";
import { buildAdminExcelDisplayRows } from "./excelSheetDisplay";

/** Omitted from WhatsApp / SMS / email only — Excel and admin cards keep these fields. */
const NOTIFY_OMITTED_LABELS = new Set(["EMI", "POS", "instalment", "Seasoning", "Address"]);

const NOTIFY_LABEL_ALIASES = {
  "Registration Numbers": "Registration No",
  "Chasis Number": "Chassis No",
  "Chasis No": "Chassis No",
};

function notifyLabel(label) {
  const aliased = NOTIFY_LABEL_ALIASES[label];
  return String(aliased || label || "")
    .replace(/\bNumbers\b/g, "No")
    .replace(/\bNumber\b/g, "No");
}

/** Message rows in the same order as the uploaded Excel sheet. */
export function buildAdminFinancerMessageRows(caseDoc = {}) {
  return buildAdminExcelDisplayRows(caseDoc, { strictLoanMobile: true })
    .filter(({ label }) => !NOTIFY_OMITTED_LABELS.has(label))
    .map(({ label, value }) => ({
      label: notifyLabel(label),
      value: safeValue(value),
    }));
}

export function appendAdminFinancerMessageBody(lines, caseDoc = {}) {
  buildAdminFinancerMessageRows(caseDoc).forEach(({ label, value }) => {
    const text = safeValue(value);
    lines.push(`${label}: ${text === "—" ? "" : text}`);
  });
  lines.push("");
}
